import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';

export interface RigidStatusPayload {
	id: number;
	venuestatus_c: 'Approved' | 'Rejected';
	reason_for_approval_rejection_c: string;
}

export interface RigidStatusResponse {
	id: number;
	venuestatus_c: string;
	reason_for_approval_rejection_c: string;
}

interface IRigidStatusMutation {
	mutate: UseMutateFunction<RigidStatusResponse, Error, RigidStatusPayload, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useRigidStatusMutation = (): IRigidStatusMutation => {
	const patchRigidStatusData = async (payload: RigidStatusPayload): Promise<RigidStatusResponse> => {
		const { id, venuestatus_c, reason_for_approval_rejection_c } = payload;

		return APIService.putData<RigidStatusResponse>(`${APICONFIG.ALL_RIGID_USER_API_RBDM}${id}/`, {
			venuestatus_c,
			reason_for_approval_rejection_c,
		});
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: patchRigidStatusData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
